<template>
  <form-card
    form
    card-without-border
    no-padding
    overflow-visible
    class="flex w-full flex-col"
    @submit.prevent="handleSubmit"
  >
    <div class="form-fields">
      <slot />
    </div>

    <div v-if="$slots.actions || submitLabel" class="mt-6">
      <!-- Centralized primary CTA: a single source of truth for the public-form
           submit button so every auth/public form shares one style and ALWAYS
           carries a leading icon. Pages can still override via the #actions
           slot for multi-button / custom flows (e.g. the login 2FA step). -->
      <slot name="actions">
        <app-button
          :id="submitId || undefined"
          :label="submitLabel"
          :icon="submitIcon"
          type="submit"
          variant="solid"
          tone="primary"
          block
          :is-loading="submitLoading"
          :disabled="submitDisabled"
        />
      </slot>
    </div>

    <div v-if="$slots.afterActions" class="mt-4">
      <slot name="afterActions" />
    </div>

    <div
      v-if="$slots.secondary"
      class="mt-4 border-t border-theme-border pt-4 text-center dark:border-theme-border"
    >
      <slot name="secondary" />
    </div>

    <div
      v-if="$slots.legal"
      class="mt-8 text-[11px] leading-5 text-theme-text-muted"
    >
      <slot name="legal" />
    </div>
  </form-card>
</template>

<script setup>
import { mdiArrowRight } from '@mdi/js';
import AppButton from '@/components/ui/buttons/AppButton.vue';
import FormCard from '@/components/ui/layout/FormCard.vue';

defineProps({
  /** When set (and no #actions slot is provided), renders the centralized
      primary submit button with this label. */
  submitLabel: { type: String, default: '' },
  /** Leading icon for the centralized submit button. Always present — defaults
      to a forward arrow so a CTA can never ship without an icon. */
  submitIcon: { type: String, default: mdiArrowRight },
  submitLoading: { type: Boolean, default: false },
  submitDisabled: { type: Boolean, default: false },
  /** Optional id on the submit button (QA hooks). */
  submitId: { type: String, default: '' },
});

const emit = defineEmits(['submit']);

const handleSubmit = (event) => {
  emit('submit', event);
};
</script>
